
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scout-methodology",
      function () {
        return require("private-next-pages/scout-methodology/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scout-methodology"])
      });
    }
  